/**
 * Created by Bob.Gear on 08/05/14.
 */
angular.module("EICDataStream3.resources")
  .factory('contractTypes', ['$resource', function ($resource) {
    return $resource('/api/contracttypes/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }])
  .factory('windTurbineManufacturers', ['$resource', function ($resource) {
    return $resource('/api/windTurbineManufacturers/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }])
  .factory('industrySectors', ['$resource', function ($resource) {
  return $resource('/api/industrysectors/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }])
  .factory('projectTypes', ['$resource', function ($resource) {
  return $resource('/api/projecttypes/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }])
  .factory('projectStages', ['$resource', function ($resource) {
  return $resource('/api/projectstages/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }])
  .factory('projectStatuses', ['$resource', function ($resource) {
  return $resource('/api/projectStatuses/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }])
  .factory('regions', ['$resource', function ($resource) {
  return $resource('/api/regions/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }])
  .factory('countries', ['$resource', function ($resource) {
  return $resource('/api/countries/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }])
  .factory('localities', ['$resource', function ($resource) {
    return $resource('/api/localities/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }])
  .factory('contractStages', ['$resource', function ($resource) {
  return $resource('/api/contractStages/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }])
  .factory('pipelineMaterials', ['$resource', function ($resource) {
  return $resource('/api/pipelineMaterials/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }])
  .factory('equipmentTypes', ['$resource', function ($resource) {
  return $resource('/api/equipmentTypes/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
  }]);
//-------------------------------------------------------------------------
// lookupTables Service
// A service to  fetch on demand and cache standing data such as lookup tables
// Consider how this cold be expanded into a more general 'VaryByParams' service
//-------------------------------------------------------------------------
angular.module("lookupTables.module", [])
  .factory('lookupTables', [
    'contractTypes',
                                                          'windTurbineManufacturers',
                                                          'industrySectors',
                                                          'projectTypes',
                                                          'projectStages',
                                                          'projectStatuses',
                                                          'regions',
                                                          'countries',
                                                          'localities',
                                                          'contractStages',
                                                          'pipelineMaterials',
                                                          'equipmentTypes',
  function (contractTypes, windTurbineManufacturers, industrySectors, projectTypes, projectStages, projectStatuses,
            regions, countries, localities, contractStages, pipelineMaterials, equipmentTypes) {
    var lookupTables = {};

    var contractTypesCollection;
    var windTurbineManufacturersCollection;
    var industrySectorsCollection;
    var projectTypesCollection;
    var projectStagesCollection;
    var projectStatusesCollection;
    var regionsCollection;
    var countriesCollection;
    var localitiesCollection;
    var contractStagesCollection;
    var pipelineMaterialsCollection;
    var equipmentTypesCollection;

    lookupTables.contractTypes = function(){
      if (!contractTypesCollection) {
        contractTypesCollection =  contractTypes.query();
      }
      // return the promise = which may be fulfilled later
      return contractTypesCollection;
    };

    lookupTables.windTurbineManufacturers = function(){
      if (!windTurbineManufacturersCollection) {
        windTurbineManufacturersCollection = windTurbineManufacturers.query();
      }
      // return the promise = which may be fulfilled later
      return windTurbineManufacturersCollection;
    };


    lookupTables.contractStages = function () {
      if (!contractStagesCollection) {
        contractStagesCollection = contractStages.query();
      }
      // return the promise = which may be fulfilled later
      return contractStagesCollection;
    };

    lookupTables.industrySectors = function () {
      if (!industrySectorsCollection) {
        industrySectorsCollection = industrySectors.query(function(sectors){
          for(var i= 0, ilen= sectors.length; i < ilen ; i++ ){
            if (sectors[i].id == 1) { // upstream
              sectors[i].equipment = [{ id: 1, name: "Wells"},
                { id: 1, name: "Flowlines"},
                { id: 1, name: "Manifolds"},
                { id: 1, name: "Field Types"},
                { id: 1, name: "Umbilicals"},
                { id: 1, name: "Risers"},
                { id: 1, name: "Pipelines"},
                { id: 1, name: "Subsea Trees"},
                { id: 1, name: "Compressors"},
                { id: 1, name: "Process Facilities"},
                { id: 1, name: "Platforms"},
                { id: 1, name: "Floating Units"}
              ];
            }
            if (sectors[i].id == 7) { // Midstream
              sectors[i].equipment = [
                { id: 1, name: "Pipelines"},
                { id: 1, name: "LNG Liquefaction"},
                { id: 1, name: "Terminals"},
                { id: 1, name: "Storage"},
                { id: 1, name: "Gas Processing"}
              ];
            }
            if (sectors[i].id == 2) { // Downstream
              sectors[i].equipment = [
                { id: 1, name: "Plant"},
                { id: 1, name: "Pipelines"},
                { id: 1, name: "Terminals"},
                { id: 1, name: "Storage"},
                { id: 1, name: "CCS Technology"},
                { id: 1, name: "CCS Storage"},
                { id: 1, name: "Captive Power Plants"},
                { id: 1, name: "Gas Processing"}
              ];
            }


            if (sectors[i].id == 3) { // Power
              sectors[i].equipment = [
                { id: 1, name: "Pipelines"},
                { id: 1, name: "Capacities"},
                { id: 1, name: "Emmission Systems"},
                { id: 1, name: "Transmission Lines"},
                { id: 1, name: "Fuel Type & Technology"},
                { id: 1, name: "CCS Technology"},
                { id: 1, name: "CCS Storage"},
                { id: 1, name: "Capex Packages"}
              ];
            }


            if (sectors[i].id == 6) { // Renewables
              sectors[i].equipment = [
                { id: 1, name: "Capacities"},
                { id: 1, name: "Wind Turbines"},
                { id: 1, name: "Solar"},
                { id: 1, name: "Geothermal"},
                { id: 1, name: "Tidal Turbines"},
                { id: 1, name: "Wave"},
                { id: 1, name: "Inter-array Cables"},
                { id: 1, name: "Power Export Cables"}             ];
            }


            if (sectors[i].id == 5) { // Other
              sectors[i].equipment = [
                { id: 4, name: "Aluminium Facilities"},
                { id: 5, name: "Rigs/Drillships"},
                { id: 5, name: "Vessels"}
              ];
            }
          }
        });
      }
      // return the promise = which may be fulfilled later
      return industrySectorsCollection;
    };

    lookupTables.projectTypes = function () {
      if (!projectTypesCollection) {
        projectTypesCollection = projectTypes.query();
      }
      // return the promise = which may be fulfilled later
      return projectTypesCollection;
    };

    lookupTables.projectStages = function () {
      if (!projectStagesCollection) {
        projectStagesCollection = projectStages.query();
      }
      // return the promise = which may be fulfilled later
      return projectStagesCollection;
    };

    lookupTables.projectStatuses = function () {
      if (!projectStatusesCollection) {
        projectStatusesCollection = projectStatuses.query();
      }
      // return the promise = which may be fulfilled later
      return projectStatusesCollection;
    };

    lookupTables.regions = function () {
      if (!regionsCollection) {
        regionsCollection = regions.query();
      }
      // return the promise = which may be fulfilled later
      return regionsCollection;
    };



      var countryDictionary = {};
      lookupTables.countries = function () {
        if (!countriesCollection) {
          countriesCollection = countries.query();
          countriesCollection.$promise.then(function(data){
            // create a hashtable so that we can get a country index from a
            // countryID
            data.forEach(function(item){
              // the item is cloned then added to the dictionary. If a direct
              // reference is added, then there are undesirable side-effects
              // because watchers detect when localities are added - and this
              // is not generally a good thing

              countryDictionary[item.id] =  angular.copy(item);
            });
          });
        }
        // return the promise = which may be fulfilled later
        return countriesCollection;
      };

    //lookupTables.localities = function (countryID) {
    //  if (!countryID) return;

    //  // get a reference to the equivalent country
    //  // from the lookupTable resource
    //  var country = countryDictionary[countryID];


    //  if (!country.localities || !country.localities.$resolved) {
    //    country.localities = localities.query({countryID: country.id});
    // }

    //  // return the promise = which may be fulfilled later
    //  return country.localities;

    //// return  localities.query({countryID: countryID});


    //};

      //lookupTables.qualifiedLocalities = function (countryID) {
      //  if (!countryID) return;

      //  // get a reference to the equivalent country
      //  // from the lookupTable resource
      //  var country = countryDictionary[countryID];

      //  if (!country.localities ) {
      //    country.localities = localities.query({countryID: country.id})
      //      .$promise
      //      .then(function (response) {
      //        response.map(function (item) {
      //          item.name = '[' + item.country + '] ' + item.name;
      //        });

      //        return response;
      //      });
      //  }

      //  // return the promise = which may be fulfilled later
      //  return country.localities;
      //};
      lookupTables.localities = function (countryID) {
        if (!countryID) return;

        // get a reference to the equivalent country
        // from the lookupTable resource
        var country = countryDictionary[countryID];

        if (!country.localities ) {
          country.localities = localities.query({countryID: country.id})
            .$promise
            .then(function (response) {
               return response;
            });
        }

        // return the promise = which may be fulfilled later
        return country.localities;
      };

    lookupTables.pipelineMaterials = function () {
      if (!pipelineMaterialsCollection) {
        pipelineMaterialsCollection = pipelineMaterials.query();
      }
      // return the promise = which may be fulfilled later
      return pipelineMaterialsCollection;
    };

    lookupTables.equipmentTypes = function () {
      if (!equipmentTypesCollection) {
        equipmentTypesCollection = equipmentTypes.query();
      }
      // return the promise = which may be fulfilled later
      return equipmentTypesCollection;
    };

    return lookupTables;
  }]);
//-------------------------------------------------------------------------

